import React from "react";

import Input, { InputProps } from "../../components/Common/Input/Input";
import { FieldErrorMessage } from "../FieldErrorMessage";
import { useFieldContext } from "../formContext";

type FormInputProps = Omit<InputProps, "name" | "value" | "onChange" | "onBlur">;

/** Number inputs store a number; an unparsable or empty value becomes "". */
const readValue = (target: HTMLInputElement): string | number => {
  if (target.type !== "number") return target.value;
  const parsed = parseFloat(target.value);
  return Number.isNaN(parsed) ? "" : parsed;
};

/**
 * Adapter: web's `Input` bound to the current field, followed by its error message. The field value
 * must be `string` (or `number` for `type="number"`); `useFieldContext<V>` is not checked against the form.
 */
export const FormInput: React.FC<FormInputProps> = (props) => {
  const field = useFieldContext<string | number>();

  return (
    <>
      <Input
        {...props}
        name={field.name}
        value={field.state.value}
        onBlur={field.handleBlur}
        onChange={(event) => field.handleChange(readValue(event.currentTarget))}
      />
      <FieldErrorMessage />
    </>
  );
};
